<template>
    <settings-control label="Text Color">
        <span class="settings-control__value">
            {{ colorDisplay }}
        </span>

        <aside class="settings-control__actions">
            <color-picker
                class="settings-control__color"
                value="#000000"
                @input="onColorInput"
            >
                <img :src="require('@/assets/ui/color-wheel.svg')">
            </color-picker>

            <button
                v-if="color"
                class="settings-control__clear"
                type="button"
                @click="onReset"
            >
                <font-awesome-icon :icon="['fal', 'undo']" />
            </button>
        </aside>
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import mapFilters from '@/utils/map-filters';

export default {
    name: 'settings-control-text-color',
    components: { SettingsControl },

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            color: this.value,
        };
    },

    computed: {
        colorDisplay() {
            return this.color ? this.upperCase(this.color) : 'Default';
        },
    },

    watch: {
        value(newVal) {
            this.color = newVal;
        },
    },

    methods: {
        ...mapFilters(['upperCase']),

        onColorInput(value) {
            this.color = value;
            this.update();
        },

        onReset() {
            this.color = '';
            this.update();
        },

        update() {
            this.$emit('input', {
                tailwindDefinitionProp: 'textColor',
                value: this.color,
            });
        },
    },
};
</script>
